import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { Navigator } from "src/app/components/menu/navigator";
import { AppstorageTsService } from "src/app/services/appstorage/appstorage.ts.service";
import { ConfigService } from "src/app/services/config/config.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { MobileToolsService } from "src/app/services/mobile-tools/mobile-tools.service";
import { MarketingService } from 'src/app/services/marketing/marketing.service';
import { UtilsService } from "src/app/services/utils/utils.service";
import { UniqueIDService } from "src/app/services/unique-id/unique-id.service";
import { EventsService } from "src/app/services/event/event.service";

@Component({
  selector: "app-tab-landing",
  templateUrl: "./tab-landing.page.html",
  styleUrls: ["./tab-landing.page.scss"],
})

export class TabLandingPage implements OnInit {
  public isAuthenticated: boolean = false;
  public splashPageSettings;
  public displayButtons: Boolean = true;
  public splashPageState = '';
  public isMobile: Boolean = false;

  public currentYear: any;
  public stateName = "";
  private timeout = 1000;

  public tapCount: number = 0;
  public tapTimeoutID: any = 0;
  public deviceId: any;
  public environment: any = "";
  public showDeviceId: boolean = false
  public isEnvSelected: boolean = false;
  public statesMap: { [key: string]: string };
  public stateLogosMap: { [key: string]: string[] } = {
    'PA': ['assets/images/PGCB.png', 'assets/images/rg_logo.png'],
    'NJ': ['assets/images/dge_logo.png', 'assets/images/njrglogo.png'],
  }
  public displayLoadingText: Boolean = true;

  public mobileStyle: string;
  public selectionText = "Select a state to play in";
  constructor(
    public config: ConfigService,
    public platform: Platform,
    public navigator: Navigator,
    public userSessionService: UserSessionService,
    public utils: UtilsService,
    public screenOrientation: ScreenOrientation,
    private appstorageTsService: AppstorageTsService,
    private mobileTools: MobileToolsService,
    private uniqueIDProvider: UniqueIDService,
    private events: EventsService,
    private marketingService: MarketingService
  ) {
  }


  async ngOnInit() {

  }

}
